import React, { useState } from "react";

import RetryFaceScan from "./RetryFaceScan";

import MugShotMaskSizing from "./MugShotMaskSizing";

import SizingScanPrepPage from "./SizingScanPrepPage";
import SizingScanChoicePage from "./SizingScanChoicePage";
import SizingScanManualPreamblePage from "./SizingScanManualPreamblePage";
import MugshotModelLoader from "../../components/mugshot/MugshotModelLoader";
import ScanInstructions from "./ScanInstructions"

import NoCameraAccessDialog from "./NoCameraAccessDialog";


import { SHOW_CAMERA_DENIED_DIALOG_INTERVAL_IN_MILLISECONDS }
from "../../components/mugshot/FaceMeasurer/MugShotConfig";

import StartScanInstructionPage from "./StartScanInstructionPage";

import {isNextGenEnabled} from "../../AppSettings";

const ChooseMaskSizingMethod = ({
  setFieldValue,
  handleSubmit,
  currentStep,
  handleNext,
  handlePrevious,
  requestTransition,
  setBackButtonOverride,
  setHelpButtonOverride,
  tokenData,
  model,
  setModel,
  modelLoadingPromise,
  setModelLoadingPromise,
  handleDoManual
}) => {

  const [errors, setErrors] = useState({timeout: true});

  const [scanAttempt, setScanAttempt] = useState(1);

  const [cameraId, setCameraId] = useState(null);

  const [showNoCameraAccessDialog, setShowNoCameraAccessDialog] = useState(false);
  const [canShowNoCameraAccessDialog, setCanShowNoCameraAccessDialog] = useState(true);

  const [localRetryCallback, setLocalRetryCallback] = useState( () => {} )

  // An array of camera dictionary entries in the format of:
  // {
  //   deviceId: ...
  //   label : ...
  //   image: ...
  // }
  const [cameraInfoArray, setCameraInfoArray] = useState([]);

  const handleCont = () => {
    handleNext();
  };

  const onUserMediaError = (e, retryCallback) =>
  {
    if ( canShowNoCameraAccessDialog ) {
      setShowNoCameraAccessDialog(true);
      setCanShowNoCameraAccessDialog(false);
    }

    // When saving functions in useState, you need a function that points to a function
    // otherwise the function will be evaluated when it is set.
    setLocalRetryCallback( () => () => retryCallback()  )

  };

  const handleManualMeasureWhenNoCameraAccess = (e) => {
    // Prevent default so that "#" isn't appended to the URL which breaks the back link
    e.preventDefault();
    setShowNoCameraAccessDialog(false);
    requestTransition("NO_CAMERA_MANUAL");
  };

  const hideNoCameraAccessDialog = () => {
    setShowNoCameraAccessDialog(false);

    // Allow camera denied modal dialog to be only shown after a specified interval has passed.
    // This allows the user the satisfaction of quiting a dialog without it reappearing immediately.
    setTimeout(setCanShowNoCameraAccessDialog, SHOW_CAMERA_DENIED_DIALOG_INTERVAL_IN_MILLISECONDS, true);

    // Signal that we want to retry accessing the camera permissions again.
    setTimeout(localRetryCallback, SHOW_CAMERA_DENIED_DIALOG_INTERVAL_IN_MILLISECONDS + 400 );
  }

  return (
      <>
        {currentStep === "sizing_scan_choice" && (
            <SizingScanChoicePage
                chooseScan={handleCont}
                chooseManual={handleDoManual}
            />
        )}

        {currentStep === "sizing_scan_manual_preamble" && (
            <SizingScanManualPreamblePage
                getStarted={handleCont}
            />
        )}


              {/* ------------------------------------------------------------------------------------------------------------
              Guarantee that the model is loaded. Generally the model will be loaded while the patient is filling out
              the question section, however, we have test code that skips the questions so if that occurs, do the loading
              now.
              ------------------------------------------------------------------------------------------------------------ */}
              {model === null && modelLoadingPromise === null && isNextGenEnabled() === false && (
                  <MugshotModelLoader
                      model={model}
                      setModel={setModel}
                      loadingPromise={modelLoadingPromise}
                      setLoadingPromise={setModelLoadingPromise}
                  />
              )}

              {currentStep === "sizing_scan_prep_mouth_closed" && (
                  <ScanInstructions handleNext={handleNext} instruction="mouth" />
              )}

              {currentStep === "sizing_scan_prep_start" && (
                  <StartScanInstructionPage
                      handleNext={handleNext}
                      handlePrevious={handlePrevious}
                  />
              )}

              {currentStep === "sizing_scan_prep_well_lit" && (
                  <ScanInstructions
                      handleNext={handleNext}
                      handlePrevious={handlePrevious}
                      instruction="lighting"
                  />
              )}

              {currentStep === "sizing_scan_prep_centered" && (
                  <ScanInstructions
                      handleNext={handleNext}
                      handlePrevious={handlePrevious}
                      instruction="centered"
                  />
              )}

              {currentStep === "sizing_scan_prep_level" && (
                  <ScanInstructions
                      handleNext={handleNext}
                      handlePrevious={handlePrevious}
                      instruction="level"
                  />
              )}

              {currentStep === "sizing_scan_prep" && (
                  <SizingScanPrepPage
                      handleNext={handleNext}
                      handlePrevious={handlePrevious}
                  />
              )}

              {currentStep === "sizing_scan_prep_glasses" && (
                  <ScanInstructions
                      handleNext={handleNext}
                      handlePrevious={handlePrevious}
                      instruction="glasses"
                      showStartScanButton={true}
                  />
              )}

              {currentStep.startsWith("sizing_scan_take_photo") && (
                  <>
                    <NoCameraAccessDialog
                        open={showNoCameraAccessDialog}
                        handleTryManualMeasure={handleManualMeasureWhenNoCameraAccess}
                        handleOKButton={hideNoCameraAccessDialog}
                    />

                    <MugShotMaskSizing
                        setFieldValue={setFieldValue}
                        handleSubmit={handleSubmit}
                        handleNext={handleNext}
                        setErrors={setErrors}
                        model={model}
                        modelLoadingPromise={modelLoadingPromise}
                        setBackButtonOverride={setBackButtonOverride}
                        setHelpButtonOverride={setHelpButtonOverride}
                        tokenData={tokenData}
                        scanAttempt={scanAttempt}
                        setScanAttempt={setScanAttempt}
                        cameraId={cameraId}
                        setCameraId={setCameraId}
                        onUserMediaError={onUserMediaError}
                        showNoCameraAccessDialog={showNoCameraAccessDialog}
                        cameraInfoArray={cameraInfoArray}
                        setCameraInfoArray={setCameraInfoArray}
                        requestTransition={requestTransition}
                    />
                  </>
              )}

              {currentStep === "sizing_scan_retry" && (
                  <>
                    <RetryFaceScan
                        errors={errors}
                        onRetry={handleNext}
                        onManual={handleDoManual}
                        setBackButtonOverride={setBackButtonOverride}
                    />
                  </>
              )}
      </>
  );
};

export default ChooseMaskSizingMethod;